@if (loaded) {
    <div class="row">

        <!-- Public access toggle -->
        @if (enablePublicAccess) {
            <div class="col-12">
                <label class="form-label">{{ 'roles.public' | translate }}</label>
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="crm-public"
                           [(ngModel)]="isPublicAccess"
                           (ngModelChange)="onPublicToggle()"
                           [disabled]="isDisabled">
                    <label class="form-check-label" for="crm-public">
                        {{ (isPublicAccess ? 'common.yes' : 'common.no') | translate }}
                    </label>
                </div>
            </div>
        }

        @if (!isPublicAccess) {

            <!-- All customers toggle -->
            @if (enableAllCustomers) {
                <div class="col-12">
                    <label class="form-label">{{ 'tousLesClients' | translate }}</label>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="crm-all-customers"
                               [(ngModel)]="isAllCustomers"
                               (ngModelChange)="onAllCustomersToggle()"
                               [disabled]="isDisabled">
                        <label class="form-check-label" for="crm-all-customers">
                            {{ (isAllCustomers ? 'common.yes' : 'common.no') | translate }}
                        </label>
                    </div>
                </div>
            }

            <!-- Custom roles list -->
            @if (!isAllCustomers) {
                <div class="col-12 col-sm-6">
                    <label class="form-label">{{ 'users.form.customCustomerRoles' | translate }}</label>

                    @for (role of roles; track role; let i = $index) {
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" id="crm-role-{{i}}"
                                   [(ngModel)]="roleCheckboxes[i]"
                                   (ngModelChange)="onRoleChange()"
                                   [disabled]="isDisabled">
                            <label class="form-check-label" for="crm-role-{{i}}">
                                {{ role['label' + crtLang.toUpperCase()] }}
                            </label>
                        </div>
                    }
                </div>
            }
        }

    </div>
}
